
import { Component, Vue } from 'vue-property-decorator';

@Component<PlaceHolderPage>({
  components: {}
})
export default class PlaceHolderPage extends Vue {}
